import React from 'react';
import PropTypes from 'prop-types';
import { Field, SelectInput } from '../../components/form/FormControls';
import { OWN_COMPANY_NAME, OWNERSHIP_TYPES, isOwnCompany } from '../../utils/stockOwnership';
import useStockText from './stockText';

/**
 * Stok ekleme/düzenleme formundaki Müşteri + Proje alanları.
 * Sarf malzemesi ve demirbaş için ortaktır; demirbaşta müşteri yerine
 * firmanın kendisi de seçilebilir.
 */
const StockScopeFields = ({
  stock,
  onScopeChange,
  customers,
  projects,
  projectsForCustomer,
  hasNoMatchingProject,
}) => {
  const { label } = useStockText();
  const isFixture = stock['Kategori'] === 'demirbas';
  const customerName = stock.customerName || '';
  // Kendi firmamız seçiliyken proje listesi daraltılmaz
  const projectOptions = isOwnCompany(customerName) ? projects : projectsForCustomer(customerName);

  let projectHint = null;
  if (projects.length === 0) projectHint = label('form.scope.projectsUnavailable');
  else if (isOwnCompany(customerName)) projectHint = label('form.scope.ownCompanyHint');
  else if (hasNoMatchingProject(customerName)) projectHint = label('form.scope.noMatchingProject');

  return (
    <>
      <Field label={isFixture ? label('form.scope.customerFixture') : label('form.scope.customer')} htmlFor="stockScopeCustomer">
        <SelectInput
          id="stockScopeCustomer"
          value={customerName}
          onChange={(e) => onScopeChange('customerName', e.target.value)}
          placeholder={label('form.scope.customerPlaceholder')}
          current={customerName}
          options={[
            ...(isFixture ? [{ value: OWN_COMPANY_NAME, label: label('form.scope.ownCompany', { name: OWN_COMPANY_NAME }) }] : []),
            ...customers.map((customer) => ({ value: customer.name, label: customer.name })),
          ]}
        />
      </Field>
      <Field label={label('form.scope.project')} htmlFor="stockScopeProject" hint={projectHint}>
        <SelectInput
          id="stockScopeProject"
          value={stock.projectName || ''}
          onChange={(e) => onScopeChange('projectName', e.target.value)}
          placeholder={label('form.scope.projectPlaceholder')}
          current={stock.projectName || ''}
          options={projectOptions.map((project) => ({ value: project.name, label: project.name }))}
        />
      </Field>
    </>
  );
};

StockScopeFields.propTypes = {
  stock: PropTypes.object.isRequired,
  onScopeChange: PropTypes.func.isRequired,
  customers: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired,
  projectsForCustomer: PropTypes.func.isRequired,
  hasNoMatchingProject: PropTypes.func.isRequired,
};

/** Demirbaşın sahiplik türü: firma malı, kiralık, müşteriye ait... */
export const StockOwnershipField = ({ value, onChange }) => {
  const { label, ownershipLabel } = useStockText();
  return (
    <Field label={label('form.ownership')} htmlFor="stockOwnershipType" hint={label('form.ownershipHint')}>
      <SelectInput
        id="stockOwnershipType"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={label('form.optional')}
        options={OWNERSHIP_TYPES.map((type) => ({ value: type.value, label: ownershipLabel(type.value) }))}
      />
    </Field>
  );
};

StockOwnershipField.propTypes = { value: PropTypes.string, onChange: PropTypes.func.isRequired };

export default StockScopeFields;
